function Navbar() {
    return (
      <nav className="navbar">
        <h1 className="logo">Autofolio Invoice Parser</h1>
      </nav>
    );
  }
  
  export default Navbar;
  